import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { ListingLayoutProps } from 'shared/components/listing-layout';
import { DataWithPaginationInterface, OrderEnum } from 'shared/types/pagination-interface';
interface UseListingFilterInterface<T extends DataWithPaginationInterface<T['items'][0]>, K, R> {
  filterData: ListingLayoutProps<T, K, R>['filterData'];
}
export const useListingFilter = t0 => {
  const $ = _c(19);
  const {
    filterData
  } = t0;
  const [isFilterShown, setIsFilterShown] = useState(false);
  const [tempState, setTempState] = useState(filterData ? filterData.filterer.filter : undefined);
  const [isDefaultValuesFetching, setIsDefaultValuesFetching] = useState(false);
  let t1;
  if ($[0] !== filterData || $[1] !== tempState) {
    t1 = () => {
      if (!filterData || !tempState) {
        return;
      }
      filterData.paginator?.setPagination({
        startFromId: undefined,
        order: OrderEnum.next
      });
      filterData.limiter?.setLimit(10);
      filterData.filterer.setFilter(tempState);
    };
    $[0] = filterData;
    $[1] = tempState;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFilter = t1;
  let t2;
  let t3;
  if ($[3] !== filterData || $[4] !== tempState) {
    t2 = () => {
      if (tempState && filterData && filterData.filterer.setResponseFilter) {
        filterData.filterer.setResponseFilter(tempState);
      }
    };
    t3 = [filterData, tempState];
    $[3] = filterData;
    $[4] = tempState;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== filterData) {
    t4 = () => {
      if (filterData) {
        const noRenderArr = filterData.filterable.filter(_temp).map(_temp2);
        setTempState(prev => {
          noRenderArr.forEach(el_1 => {
            if (prev) {
              prev[el_1] = filterData.filterer.defaultFilters[el_1] as NonNullable<K>[keyof K];
            }
          });
          return prev;
        });
      }
    };
    t5 = [filterData];
    $[7] = filterData;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== filterData?.filterer.filter) {
    t6 = () => {
      setTempState(filterData?.filterer.filter);
    };
    $[10] = filterData?.filterer.filter;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = filterData?.filterer.filter;
  let t8;
  if ($[12] !== t7) {
    t8 = [t7];
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  useEffect(t6, t8);
  let t9;
  if ($[14] !== handleFilter || $[15] !== isDefaultValuesFetching || $[16] !== isFilterShown || $[17] !== tempState) {
    t9 = {
      isFilterShown,
      setIsFilterShown,
      tempState,
      setTempState,
      isDefaultValuesFetching,
      setIsDefaultValuesFetching,
      handleFilter
    };
    $[14] = handleFilter;
    $[15] = isDefaultValuesFetching;
    $[16] = isFilterShown;
    $[17] = tempState;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
function _temp(el) {
  return el.shouldRender === false;
}
function _temp2(el_0) {
  return el_0.field;
}